export default __webpack_public_path__ + "static/PAPC_2022_ChallengePatrik_ HU_V2.0-0ac5339a744392a2d4146e158c2554b4.pdf";